<template>
	<div class="dictionary">
		<v-search-dict
			v-on:addDict="addDict"
			:dict="dict"
			v-on:onSubmit="onSubmit"
			v-on:delBatchDict="delBatchDict"
			v-on:resetSearch="resetSearch"
			:multipleSelection="multipleSelection"
		></v-search-dict>
		<v-add-dict
			:dialogDict="dialogDict"
			:addOrEdit="addOrEdit"
			:dictForm="dictForm"
			v-on:cancel="cancel"
		></v-add-dict>
		<div class="dict vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="dictList"
				style="width: 100%"
				max-height="638"
				:border="true"
				@selection-change="handleSelectionChange"
			>
				<el-table-column
					type="selection"
					fixed
					width="40"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="name"
					:label="$t('dictType.dictName')"
					width="180"
					:align="'center'"
				></el-table-column>
				<el-table-column
					:label="$t('dictType.dictType')"
					width="180"
					:align="'center'"
				>
					<template slot-scope="scope">
						<router-link
							:to="'/dictionary-data/' + scope.row.id + '/' + scope.row.type"
							class="link-type"
							>{{ scope.row.type }}
						</router-link>
					</template>
				</el-table-column>

				<el-table-column
					prop="notes"
					:label="$t('dictType.notes')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('dictType.createTime')"
					width="170"
					:align="'center'"
				>
					<template slot-scope="scope">
						<span class="times">{{ scope.row.createTime }}</span>
					</template>
				</el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 150 : 155"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-button size="mini" @click="editDict(scope.row)">{{
							$t("common.edit")
						}}</el-button>
						<el-button type="danger" size="mini" @click="delDict(scope.row)">{{
							$t("common.delete")
						}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import vSearchDict from "@/components/system/SearchDictType";
import vAddDict from "@/components/system/AddDictType";
export default {
	name: "DictionaryType",
	components: {
		vSearchDict,
		vAddDict,
	},
	data() {
		return {
			dictList: [],
			dict: {
				name: "",
				type: "",
			},
			page: {
				pageIndex: 1,
				pageSize: 10,
				totalSize: 0,
			},
			loading: false,
			dialogDict: false,
			addOrEdit: false,
			dictForm: {
				name: "",
				type: "",
				notes: "",
			},
			multipleSelection: [],
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.dict, this.page);
			this.$api
				.request(this.$url.DictType.loadDictType, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.dictList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
				this.loading = false;
			});
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},

		addDict() {
			this.dialogDict = true;
			this.addOrEdit = true;
		},

		resetSearch(dict) {
			this.dict = dict;
			this.currentChange();
		},

		onSubmit(dict) {
			this.dict = dict;
			this.currentChange();
		},

		handleSelectionChange(row) {
			this.multipleSelection = row;
		},

		editDict(row) {
			this.dialogDict = true;
			this.addOrEdit = false;
			Object.keys(this.dictForm).forEach(key => {
				this.dictForm[key] = row[key];
			});
			this.dictForm.id = row.id;
		},
		delDict(row) {
			this.$confirm(this.$t("dictType.isDel"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.DictType.delete, this.$method.delete, {
						ids: [row.id],
					})
					.then(res => {
						if (res.code === 0) {
							this.$message.success(this.$t("dictType.del"));
							this.currentChange();
						}
					});
			});
		},
		cancel(dialogDict, state) {
			this.dialogDict = dialogDict;
			if (state) {
				this.currentChange();
			}
		},
		// 批量删除
		delBatchDict() {
			if (this.multipleSelection.length > 0) {
				this.$confirm(this.$t("dictType.isSeDel"), this.$t("common.tip"), {
					confirmButtonText: this.$t("common.definite"),
					cancelButtonText: this.$t("common.cancel"),
					type: "warning",
				}).then(() => {
					let dictTypeIds = this.getDictTypeId(this.multipleSelection);
					this.$api
						.request(this.$url.DictType.delete, this.$method.delete, {
							ids: dictTypeIds,
						})
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.success"),
									message: this.$t("dictType.del"),
									type: "success",
								});
								this.currentChange();
							}
						});
				});
			}
		},

		getDictTypeId(selectIds) {
			let obj = [];
			selectIds.forEach(key => {
				obj.push(key.id);
			});
			return obj;
		},
	},
};
</script>

<style lang="scss">
.el-dialog__header {
	padding: 20px;
}
.el-dialog__body {
	padding: 0 20px;
	height: auto !important;
}
.el-dialog__footer {
	padding: 20px;
}
.dictionary {
	.link-type:link {
		color: #337ab7;
	}
	.link-type:visited {
		color: #337ab7;
	}
}
</style>
